import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
import Button from '../button/Button';
import SimpleTooltip from '../tooltip/SimpleTooltip';
const SidebarFullscreenToggle = ({ isFullscreen, tooltip, onClick = noop }) => {
    const fullscreenIconClasses = classNames('rioglyph', isFullscreen ? 'rioglyph-resize-small' : 'rioglyph-resize-full');
    const button = (_jsx(Button, Object.assign({ bsStyle: Button.MUTED, iconOnly: true, onClick: onClick, "data-testid": 'sidebarFullscreenToggle' }, { children: _jsx("span", { className: fullscreenIconClasses }) })));
    if (tooltip) {
        return (_jsx(SimpleTooltip, Object.assign({ content: tooltip, placement: 'bottom' }, { children: button })));
    }
    return button;
};
export default SidebarFullscreenToggle;
